import { RouterView } from "vue-router";
import { DepartmentRouting } from "./department/department.routing";
import { EmployeeRouting } from "./employee/employee.routing";
import { RoleRouting } from "./role/role.routing";
import { RoleUserRouting } from "./role-user/role-user.routing";
import { AuthSealRouting } from "./auth-seal/auth-seal.routing";

export const OrganizationRouting = {
  path: "/organization",
  name: "organization",
  redirect: "/organization/structure/list",
  component: RouterView,
  meta: { title: "组织管理", icon: "zuzhi" },
  children: [...DepartmentRouting, ...EmployeeRouting, ...RoleRouting, ...RoleUserRouting, ...AuthSealRouting],
};
